import React from 'react';
import { TagShapeProps } from '../utils/common-graph.utils';
import { GRID_UNIT_SIZE } from '../utils/graph.utils';

export const LaddergramLightning: React.FC<TagShapeProps> = ({ color }) => {
  return (
    <g>
      <path
        fill={color}
        strokeWidth={GRID_UNIT_SIZE}
        d='M3.5,1V6.5H5V11L8.5,5H6.5L8.5,1H3.5Z'
      />
    </g>
  );
};
